import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import React from 'react'

import { bonusTableData } from '../constants'
import { formatNumber } from '../utils'

const BonusPotentialTable: React.FC = () => {
  return (
    <Box sx={{ mt: 6, mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 2, fontFamily: 'Lexend-SemiBold' }}>
        Bonus Potential by Average Weekly Sales
      </Typography>
      <TableContainer>
        <Table
          size="small"
          sx={{
            '& .MuiTableCell-root': { padding: '4px 6px' },
            '& .MuiTableCell-head': {
              whiteSpace: 'normal',
              lineHeight: '1.2',
            },
            '& tr:nth-of-type(odd)': {
              backgroundColor: '#f5f5f5',
            },
            // Add vertical dividers between sections
            '& tr:first-child > th': {
              borderRight: '2px solid #e0e0e0',
            },
            '& tr:first-child > th:last-child': {
              borderRight: 'none',
            },
            '& th:nth-of-type(3), & td:nth-of-type(3)': {
              borderRight: '2px solid #e0e0e0',
            },
            '& th:nth-of-type(6), & td:nth-of-type(6)': {
              borderRight: '2px solid #e0e0e0',
            },
            width: '50%',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={3}
                align="center"
                sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
              >
                Sales
              </TableCell>
              <TableCell
                colSpan={3}
                align="center"
                sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
              >
                Operator Bonus (Quarterly)
              </TableCell>
              <TableCell
                colSpan={4}
                align="center"
                sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
              >
                Manager Bonus (Quarterly)
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '50px',
                  fontFamily: 'Lexend-Regular',
                }}
              >
                Annual
              </TableCell>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '50px',
                  fontFamily: 'Lexend-Regular',
                }}
              >
                Quarterly
              </TableCell>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '50px',
                  fontFamily: 'Lexend-Regular',
                }}
              >
                Weekly
              </TableCell>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '50px',
                  fontFamily: 'Lexend-Regular',
                }}
              >
                Prime Cost
              </TableCell>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '50px',
                  fontFamily: 'Lexend-Regular',
                }}
              >
                Guest
              </TableCell>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '50px',
                  fontFamily: 'Lexend-SemiBold',
                }}
              >
                Total
              </TableCell>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '50px',
                  fontFamily: 'Lexend-Regular',
                }}
              >
                Prime Cost
              </TableCell>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '50px',
                  fontFamily: 'Lexend-Regular',
                }}
              >
                Guest
              </TableCell>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '50px',
                  fontFamily: 'Lexend-Regular',
                }}
              >
                Pool
              </TableCell>
              <TableCell
                sx={{
                  padding: '4px 6px',
                  whiteSpace: 'normal',
                  maxWidth: '75px',
                  fontFamily: 'Lexend-SemiBold',
                }}
              >
                Each (2 Mgrs)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bonusTableData.map((row, index) => (
              <TableRow
                key={index}
                sx={{ '&:nth-of-type(odd)': { backgroundColor: '#fafafa' } }}
              >
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
                >
                  {formatNumber(row.salesAnnually, false, false, 0)}
                </TableCell>
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
                >
                  {formatNumber(row.salesQuarterly, false, false, 0)}
                </TableCell>
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
                >
                  {formatNumber(row.salesWeekly, false, false, 0)}
                </TableCell>
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
                >
                  {formatNumber(
                    row.opPrimeCostBonusPotential / 4,
                    false,
                    false,
                    0,
                  )}
                </TableCell>
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
                >
                  {formatNumber(
                    row.opGuestMetricBonusPotential / 4,
                    false,
                    false,
                    0,
                  )}
                </TableCell>
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-SemiBold' }}
                >
                  {formatNumber(row.opBonusPotential / 4, false, false, 0)}
                </TableCell>
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
                >
                  {formatNumber(
                    row.managerPrimeCostBonusPotential / 4,
                    false,
                    false,
                    0,
                  )}
                </TableCell>
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
                >
                  {formatNumber(
                    row.managerGuestMetricBonusPotential / 4,
                    false,
                    false,
                    0,
                  )}
                </TableCell>
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-Regular' }}
                >
                  {formatNumber(
                    row.managerBonusPotentialPool / 4,
                    false,
                    false,
                    0,
                  )}
                </TableCell>
                <TableCell
                  sx={{ padding: '4px 6px', fontFamily: 'Lexend-SemiBold' }}
                >
                  {formatNumber(
                    row.twoManagerPerStoreIndividualManagerAverage / 4,
                    false,
                    false,
                    0,
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default BonusPotentialTable
